import axios from "axios";
import { apiUrl } from "config";

export type ReserveTermsData = {
  address: string;
  tokenIds: number[];
};

export const reserveTokens = async ({
  tokenIds,
  address,
}: ReserveTermsData): Promise<void> => {
  await axios.post<{ tokenId: number; quantity: number }[]>(
    "/reserve",
    { tokenIds, address },
    {
      baseURL: apiUrl,
    }
  );
  return;
};
